export const EDIT = 'Edit';
export const DELETE = 'Delete';

export const ORG_MENU_OPTION = [
    { label: EDIT, value: EDIT },
    { label: DELETE, value: DELETE },
];
